export default {
  // 对话框标题
  saveCanvas: "保存画布",
  addNewCaseAndSaveCanvas: "添加新案件并保存画布",

  // 表单标签
  canvasName: "画布名称",
  relatedCase: "关联案件",
  canvasDescription: "画布描述",
  caseName: "案件名称",
  caseType: "案件类型",
  caseTypeName: "案件类型名称",
  caseDescription: "案件说明",

  // 占位符
  pleaseEnterCanvasName: "请输入画布名称(必填)",
  selectOrSearchCase: "请选择或搜索案件",
  pleaseEnterCanvasDescription: "请输入画布描述（200字以内）",
  pleaseEnterCaseName: "请输入案件名称(必填)",
  pleaseSelectCaseType: "请选择案件类型(必填)",
  pleaseSelectCaseTypeName: "请选择案件类型名称",
  pleaseEnterCaseDescription: "请输入案件说明",

  // 按钮
  cancel: "取消",
  confirm: "确认",
  saveCaseAndCanvas: "保存案件&画布",
  addNewCase: "添加新案件",

  // 区域标题
  canvasInfo: "画布信息",
  addNewCaseTitle: "添加新案件",

  // 验证消息
  canvasNameRequired: "画布名称为必填项",
  caseRequired: "案件为必选项",
  caseNameRequired: "案件名称为必填项",
  caseNameLength: "长度在 1 到 20个字符",
  pleaseSelectCaseTypeValidation: "请选择案件类型",
  caseDescriptionLength: "长度在 1 到 200个字符",

  // 成功消息
  saveSuccess: "保存成功",

  // 画布类型
  singleCurrencyCanvas: "单币种画布",
  multiCurrencyCanvas: "多币种画布",
};
